import moment from "moment";

function checkMemberMeetsAwardCriteria(data, member) {
  let passed = false;
  let messages = [];
  let age = moment(data.competition.age_reference_date).diff(
    member.birthDate,
    "years",
    false
  );

  // TODO: Need to allow for the award that allows for any age
  if (
    (data.filterToEvent.gender == "X" ||
      data.filterToEvent.gender == member.gender ||
      data.playerLabel.mixed == 1) &&
    ((age >= data.filterToEvent.age_min &&
      age <= data.filterToEvent.age_max) ||
      (data.playerLabel.noMaxAge == 1 && age >= 14))
  ) {
    passed = true;
  } else {
    return {
      passed: false,
      messages: ['Athlete does not meet the Age requirement for this Event']
    };
  }

  if (
    (data.excludeAthletesIds && data.excludeAthletesIds.includes(member.id))) {
    return {
      passed: false,
      messages: ['Athlete is already in a team for this event']
    };
  }

  if (data.playerLabel && member.crm_id) {
    let result = checkAwards(
      data.playerLabel,
      data.filterToEvent,
      member,
      data.competition
    );
    messages.messages = result.messages;
    passed = result.display;
  }

  return { passed: passed, messages: messages };
}

function checkAwards(playerLabels, event, member, competition) {
  let result = {
    passed: true,
    display: true,
    messages: [],
  };

  let age = moment(competition.age_reference_date).diff(
    member.birthDate,
    "years",
    false
  );

  // Check crew award
  if (playerLabels.crew == 1) {
    let award = member.awards.find((a) => a.awards_id == 4);
    if (!award) {
      result.passed = false;
      result.messages.push("Athlete has no valid IRB Crew award");
    }
  }

  // Check driver award
  if (playerLabels.driver == 1) {
    let award = member.awards.find(
      (a) =>
        (a.awards_id == 2 || a.awards_id == 6) &&
        moment(a.refresher_date) >= moment(event.refresher_reference_date)
    );
    if (!award) {
      result.passed = false;
      result.messages.push("Athlete has no valid IRB Driver award");
    }
  }

  // Check patrolSupport award
  if (playerLabels.patrolSupport == 1 && age >= 14) {
    let award = member.awards.find(
      (a) =>
        (a.awards_id == 15 ||
          a.awards_id == 11 ||
          a.awards_id == 2 ||
          a.awards_id == 5 ||
          a.awards_id == 6 ||
          a.awards_id == 22 ||
          a.awards_id == 23) &&
        moment(a.refresher_date) >= moment(event.refresher_reference_date)
    );
    if (!award) {
      result.passed = false;
      result.messages.push(
        "Athlete has no valid Patrol Support or SLG award"
      );
    }
  }

  // check slg award
  if (playerLabels.slg == 1 && age >= 14) {
    let award = member.awards.find(
      (a) =>
        (a.awards_id == 22 || a.awards_id == 23) &&
        moment(a.refresher_date) >= moment(event.refresher_reference_date)
    );
    if (!award) {
      result.passed = false;
      result.messages.push("Athlete has no valid SLG award");
    }
  }

  // check twoHundredMeter award
  if (playerLabels.twoHundredMeter == 1 && age < 14) {
    // Calculating the members age because this award only applies after they are 14
    // let age = moment(event.refresher_reference_date).diff(
    //   member.birthDate,
    //   "years",
    //   false
    // );

    let award = member.awards.find(
      (a) =>
        (a.awards_id == 3 || a.awards_id == 17) &&
        moment(a.refresher_date) >= moment(event.refresher_reference_date)
    );
    if (!award) {
      result.passed = false;
      result.messages.push("Athlete has no valid 200m award");
    }
  }

  return result;
}

export { checkMemberMeetsAwardCriteria };
